import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL.replace(/\/$/, "")}/api/v1`;
export const api = axios.create({ baseURL: API, timeout: 15000, headers: { "Content-Type": "application/json" } });
const publicAuth = (url) => /^\/auth\/(login|register|refresh)(?:\?|$)/.test(String(url || ""));

export function clearSession() {
    localStorage.removeItem("warungpay_token");
    localStorage.removeItem("warungpay_refresh_token");
    delete api.defaults.headers.common.Authorization;
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("warungpay_token");
    if (token && !publicAuth(config.url)) config.headers.Authorization = `Bearer ${token}`;
    else delete config.headers.Authorization;
    return config;
});

// All expired requests await one refresh, including its rejection.
let refreshRequest = null;
api.interceptors.response.use((response) => response, async (error) => {
    if (error?.code === "ECONNABORTED") error.message = "Permintaan ke server timeout. Silakan coba lagi.";
    const original = error?.config;
    if (original?.noAutomaticRetry) throw error;
    if (error?.response?.status !== 401 || !original || original._retry || publicAuth(original.url)) throw error;
    const refreshToken = localStorage.getItem("warungpay_refresh_token");
    if (!refreshToken) {
        clearSession();
        window.dispatchEvent(new Event("warungpay:session-expired"));
        throw error;
    }
    original._retry = true;
    if (!refreshRequest) {
        refreshRequest = axios.post(`${API}/auth/refresh`, { refreshToken }, { timeout: 15000 })
            .then(({ data }) => {
                const token = data.accessToken ?? data.token;
                if (!token || !data.refreshToken) throw new Error("Respons sesi tidak valid. Silakan masuk kembali.");
                // Do not restore a session that was logged out while refreshing.
                if (localStorage.getItem("warungpay_refresh_token") !== refreshToken) throw new Error("Sesi telah berubah.");
                localStorage.setItem("warungpay_token", token);
                localStorage.setItem("warungpay_refresh_token", data.refreshToken);
                return token;
            })
            .catch((refreshError) => {
                if (localStorage.getItem("warungpay_refresh_token") === refreshToken) {
                    clearSession();
                    window.dispatchEvent(new Event("warungpay:session-expired"));
                }
                throw refreshError;
            })
            .finally(() => { refreshRequest = null; });
    }
    const token = await refreshRequest;
    original.headers.Authorization = `Bearer ${token}`;
    return api(original);
});

export function formatApiError(err) {
    const response = err?.response?.data;
    const detail = response?.message ?? response?.detail;
    if (detail == null) return err?.message || "Terjadi kesalahan";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => typeof e === "string" ? e : e?.msg || JSON.stringify(e)).join(", ");
    return detail?.msg || JSON.stringify(detail);
}

export function formatIDR(value) {
    if (value == null || !Number.isFinite(Number(value))) return "Rp 0";
    return "Rp " + Number(value).toLocaleString("id-ID");
}

export function formatDate(iso) {
    if (!iso) return "-";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
